module.exports = __webpack_public_path__ + "static/media/excel.1a88cab4.mp3";